import { IComponentOptions } from "angular";
import { ChangeUserPictureModalService } from "@gtmhub/users";

interface IChangeUserPictureBindings {
  userId: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ChangeUserPictureCtrl extends IChangeUserPictureBindings {}
class ChangeUserPictureCtrl {
  static $inject = ["ChangeUserPictureModalService"];

  constructor(private changeUserPictureModalService: ChangeUserPictureModalService) {}

  openChangeUserPictureModal(): void {
    this.changeUserPictureModalService.openChangeUserPictureModal(this.userId);
  }
}

export const ChangeUserPictureComponent: IComponentOptions = {
  controller: ChangeUserPictureCtrl,
  template: require("./change-user-picture.component.html"),
  bindings: {
    userId: "<",
  },
};
